var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderComissionSchedule',{attrs:{"id":_vm.id}}),_c('ListComissionSchedule',{attrs:{"id":_vm.id}}),_c('EditComissionSchedule',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }